import { render, staticRenderFns } from "./report-individual-payment-view.vue?vue&type=template&id=61cb633c&"
import script from "./report-individual-payment-view.vue?vue&type=script&lang=js&"
export * from "./report-individual-payment-view.vue?vue&type=script&lang=js&"
import style0 from "./report-individual-payment-view.vue?vue&type=style&index=0&id=61cb633c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports